import React from 'react'
import { GoogleLogo } from 'components/misc/Icons'

export default function Test() {
    return (
        <div className="flex flex-col">
            <div className="container mx-auto">
                <div className="flex flex-row items-center justify-between h-12">
                    <div>
                        <h1 className="text-2xl font-bold tracking-tight text-authblue">an app</h1>
                    </div>
                    <div>
                        <button className="text-sm font-light text-authblue">English (UK)</button>
                    </div>
                </div>
            </div>

            <div className="container mx-auto">
                <div className="flex flex-row">
                    <div className="flex justify-start w-1/2">
                        <div className="mt-40">
                            <h2 className="font-black leading-none tracking-tight text-8xl gradientfill bg-clip-text">Create your<br/>best life</h2>
                            <p>Record your life and live it again and again.</p>
                        </div>
                    </div>
                    <div className="flex flex-row justify-center w-1/2">
                        <div className="p-8 rounded-lg mt-28 bg-itemlight w-140">
                            <form>
                                <div>
                                    <h3 className="text-3xl font-bold tracking-tight">Create a new account</h3>
                                    <p className="text-textlight">Join today and start making memories.</p>
                                </div>
                                <div className="mt-6 space-y-4">
                                    <div>
                                        <label
                                            htmlFor=""
                                            className="text-sm text-textlight">Enter a username</label>
                                        <input
                                            type="text"
                                            className="w-full h-10 mt-1 border rounded-lg border-borderlighthover"
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor=""
                                            className="text-sm text-textlight">Enter your email address</label>
                                        <input
                                            type="email"
                                            className="w-full h-10 mt-1 border rounded-lg border-borderlighthover"
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor=""
                                            className="text-sm text-textlight">Password</label>
                                        <input
                                            type="password"
                                            className="w-full h-10 mt-1 border rounded-lg border-borderlighthover"
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor=""
                                            className="text-sm text-textlight">Confirm password</label>
                                        <input
                                            type="password"
                                            className="w-full h-10 mt-1 border rounded-lg border-borderlighthover"
                                        />
                                    </div>
                                    <div className="">
                                        <button className="w-full h-12 mt-2 font-medium text-center text-white border rounded-lg bg-authblue border-authblue">Sign up</button>
                                    </div>
                                </div>
                                <hr className="w-full my-6 border-borderlighthover"/>
                                <div className="">
                                    <button className="flex items-center justify-center w-full h-12 mt-2 space-x-3 font-medium text-center border rounded-lg hover:text-white bg-itemlight text-authblue border-borderlighthover hover:bg-authblue hover:border-authblue">
                                        <GoogleLogo/>
                                        <span className="">Sign up with Google</span>
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
